import {
  TimesheetExcludedUsers,
  TimesheetExcludedUserState,
  UserId,
} from './types';

export const asList = (state: TimesheetExcludedUsers): UserId[] =>
  state[0] === 'just' ? Object.keys(state[1]).map(Number) : [];
export const asNonRemovedList = (state: TimesheetExcludedUsers): UserId[] =>
  state[0] === 'just'
    ? Object.entries(state[1])
        .filter(([_, status]) => status !== TimesheetExcludedUserState.Removing)
        .map(([id]) => Number(id))
    : [];
export const isInAdding =
  (id: UserId) =>
  (state: TimesheetExcludedUsers): boolean => {
    if (state[0] !== 'just') {
      return false;
    }
    const { [id]: status } = state[1];

    return status === TimesheetExcludedUserState.Adding;
  };
export const isUserExcludedFromTimesheet =
  (id: UserId) =>
  (state: TimesheetExcludedUsers): boolean => {
    const { [id]: status } = state[1] ?? {};

    return status != null && status !== TimesheetExcludedUserState.Removing;
  };
